import { Component, Input } from '@angular/core';

import { ApiError, MessageService } from '../../../core';
import { TituloReceberResumo } from './titulo-receber-resumo';
import { TituloReceberResumoFilter } from './filter';
import { TituloReceberResumoHttpService } from './services';

@Component({
    selector: 'sgt-titulo-receber-resumo',
    templateUrl: './titulo-receber-resumo.component.html',
    styleUrls: ['./titulo-receber-resumo.component.less']
})
export class TituloReceberResumoComponent {
    entity = new TituloReceberResumo();

    constructor(private messageService: MessageService,
                private tituloReceberResumoHttpService: TituloReceberResumoHttpService) { }

    /** Obtem o resumo dos títulos a receber **/
    getResumo(filter: TituloReceberResumoFilter) {
        this.entity = new TituloReceberResumo();
        this.tituloReceberResumoHttpService.getResumo(filter)
            .subscribe(
                entity => this.entity = entity,
                (error: ApiError) => this.messageService.error(error.message, 'Erro ao obter o resumo dos títulos', error)
            )
    }
}
